var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "add_icon",
    "data-name": "add icon",
    transform: "translate(-645 -543)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "add_new_icon",
    "data-name": "add new icon",
    transform: "translate(-445 172)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1025",
    "data-name": "Rectangle 1025",
    transform: "translate(1090 371)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 17,
    rx: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 19,
    height: 16,
    rx: 1.5,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_25741",
    "data-name": "Path 25741",
    d: "M15.586,18a.6.6,0,0,0-.6.6v2.391H12.6a.6.6,0,0,0,0,1.2h2.391v2.391a.6.6,0,0,0,1.2,0V22.184h2.391a.6.6,0,0,0,0-1.2H16.184V18.6a.6.6,0,0,0-.6-.6",
    transform: "translate(639.414 529.914)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddIcon);
export default __webpack_public_path__ + "static/media/add-icon.0692c1f93042cac90fe309f6487dd769.svg";
export { ForwardRef as ReactComponent };